import { cn } from 'src/shared/utils/cn'

type FilterPillBarProps = {
  filters: {
    label: string
    value: string
  }[]
  activeFilter: string
  onFilterChange: (filter: string) => void
}

const FilterPillBar = ({ filters, activeFilter, onFilterChange }: FilterPillBarProps) => {
  return (
    <div className="flex flex-row gap-2 overflow-x-auto">
      {filters.map((filter) => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          className={cn(
            'flex h-[32px] items-center justify-center rounded-full px-4 py-2 text-xs',
            activeFilter === filter.value ? 'bg-primary text-white' : 'bg-white text-primary hover:bg-primary/10',
          )}
        >
          {filter.label}
        </button>
      ))}
    </div>
  )
}

export default FilterPillBar
